import React from "react";
import { useTranslation } from "react-i18next";
import { handleScrollTop } from "../../../util";
import "./style.scss";

const ScrollToTop = () => {
  const { t } = useTranslation("productDetails");

  return (
    <button className="scrollToTop" onClick={() => handleScrollTop("smooth")}>
      {t("scrollToTop")}
    </button>
  );
};

export default ScrollToTop;
